module.exports = function(app){

// 	SIMPLE USE:
//		* uses data-lat-lng first || data-address
//		* Anything inside the marker is transcluded into the marker infoWindow
//		* You can ng-repeat over a list of markers
//	<section data-map-view="map">
//		<div data-marker data-lat-lng="selectedLocation.address.latLng" data-address="selectedLocation.address" data-center="'true'">
//			<div data-portal-address="selectedLocation.address"></div>
//		</div>
//	</section>

	app.directive("mapView", ["mapServices", "$q", function(mapServices, $q){
		return {
			transclude: true,
			scope: {
				mapView: "=",
				zoom: "=",
				maxZoom:"=",
				hideButtons:"=?",
				hideStreetViewInFullScreen:"=?",
				hideId:"=?"
			},
			template:   "<div class='hm-map'>" +
						"    <div class='mapContainer'></div>" +
						"    <div class='contentContainer'><div data-ng-transclude></div></div>" +
						"</div>",
			controller: ["$scope", function($scope) {
				$scope.mapView = $scope.mapView || {};
				$scope.mapView.markers = [];
				$scope.mapView.defer = $q.defer();
				$scope.mapView.isLoading = $scope.mapView.defer.promise;

				this.mapView = $scope.mapView;
				this.addToMarkerList = function(marker) {
					$scope.mapView.markers.push(marker);
				};
				this.removeFromMarkerList = function(marker) {
					$scope.mapView.markers.forEach(function(item, index, obj){
						if (item.latLng.lat === marker.lat &&
							item.latLng.lng === marker.lng) {
							$scope.mapView.markers[index].setMap(null);
						}
					});
				};

				$scope.$watch("zoom", function(){
					if ($scope.zoom) {
						mapServices.setZoomToMap($scope.zoom, $scope.mapView.reference);
					}
				});
				$scope.$watch("mapView.markers.length", function(){
					if ($scope.mapView.markers.length > 0) {
						mapServices.setBoundingBoxToMap($scope.mapView.markers, $scope.mapView.reference);
						// drop those pins and reset!
						var center = $scope.mapView.reference.getCenter();
						window.google.maps.event.trigger($scope.mapView.reference, 'resize');
						$scope.mapView.reference.setCenter(center);

					}
				});
			}],
			link: function($scope, element) {
				var hide;
				if($scope.hideButtons){
					 hide = true;
				}
				var hideStreetViewInFullScreen
				if($scope.hideStreetViewInFullScreen == true){
					hideStreetViewInFullScreen = true;
				}
				mapServices.createMapAtElement(element.find(".mapContainer")[0],null,hide,hideStreetViewInFullScreen,$scope.hideId).then(function(mapReference){
					$scope.mapView.reference = mapReference;
					mapServices.setMaxZoom($scope.maxZoom, $scope.mapView.reference);
					/*call back method to do things on info window open like coremetrics*/
					$scope.mapView.reference.doThingsOnInfoWindowOpen=function(){
						if($scope.mapView.doThingsOnInfoWindowOpen && angular.isFunction($scope.mapView.doThingsOnInfoWindowOpen)){
							$scope.mapView.doThingsOnInfoWindowOpen();
						}
					};
					$scope.mapView.defer.resolve();
				}).then(function(){
					if ($scope.zoom) {
						mapServices.setZoomToMap($scope.zoom, $scope.mapView.reference);
					}
				},
				function(){
					console.log("no mapping functions available");
				});
			}
		};
	}]);
	app.directive("marker", ["mapServices", "$q", function(mapServices, $q){
		return {
			require: "^mapView",
			scope: {
				latLng: "=?",
				address: "=",
				center: "=",
				color: "=?"
			},
			link: function ($scope, element, attr, $parent) {
				$scope.mapView = $parent.mapView;
				var info = element[0];
				$scope.$watch(function(){ return $scope.latLng; }, function(newValue, oldValue){
					if (newValue !== oldValue) {
						$parent.removeFromMarkerList(oldValue);
						var marker = mapServices.addMarkersToMap({
							latLng: {lat: $scope.latLng.lat, lng: $scope.latLng.lng},
							infoWindowContent: info
						}, $scope.mapView.reference,$scope.color);
						if ($scope.center) {
							mapServices.centerMapToMarker($scope.mapView.reference, { lat: $scope.latLng.lat, lng: $scope.latLng.lng });
						}
						$parent.addToMarkerList(marker);
					}
				}, true);
				$scope.mapView.isLoading.then(function(){
					if ($scope.address && $scope.address.city && $scope.address.state) {
						// we need a latLng
						var address = mapServices.formatMailingAddressObject($scope.address);
						if (address) {
							mapServices.getLatLngFromFormattedAddress(address).then(
								function(response) {
									//set coordinates in address which can be re-used later
									if(!$scope.address.latLng){
										$scope.address.latLng=response.latLng;
									}

									var marker = mapServices.addMarkersToMap({
										latLng: response.latLng,
										infoWindowContent: info
									}, $scope.mapView.reference,$scope.color);
									if ($scope.center) {
										mapServices.centerMapToMarker($scope.mapView.reference, response.latLng);
									}
									$parent.addToMarkerList(marker);
								}
							);
						}
					}
					else if ($scope.latLng && $scope.latLng.lat && $scope.latLng.lng) {
						// we have a lat/lng
						var marker = mapServices.addMarkersToMap({
							latLng: {lat: $scope.latLng.lat, lng: $scope.latLng.lng},
							infoWindowContent: info
						}, $scope.mapView.reference,$scope.color);
						if ($scope.center) {
							mapServices.centerMapToMarker($scope.mapView.reference, { lat: $scope.latLng.lat, lng: $scope.latLng.lng });
						}
						$parent.addToMarkerList(marker);
					}
				});
			}
		};
	}]);
};
